import { jsx as e, jsxs as p, Fragment as q } from "react/jsx-runtime";
import { withManagedProps as P } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import O, { useEffect as F, useState as U, isValidElement as Xt, useRef as We, useCallback as Ge, useMemo as Qt } from "react";
import { p as Zt, a as qt, b as ee, c as Jt, s as ea, d as ta, e as aa, f as na, g as oa, h as sa, i as ia, j as ra, k as la, l as ca, m as da, n as ua, o as pa, q as ma, r as ha, t as ba, u as ga, v as Ae, w as fa, x as va, y as Pa, z as ya, A as Sa, B as wa, C as _a, D as ka, E as Na, F as Ta, G as Ca, H as Aa, I as Ba, J as ve } from "./blueprint-bed8526e.mjs";
import { Drawer as M } from "@made-people/blueprint-drawer";
import * as de from "@radix-ui/react-dialog";
import { useOverlayState as Da, overlayEventEmitter as ue } from "@made-people/blueprint-overlay";
import { useProductBase as j, ProductLink as Se, useProductAttributeGetter as ne, useProductPriceInfo as be, useProductDataModel as J, useBundlePurchaseInfo as Be, useProductImages as Ia, useMediaAttributeGetter as je, useRelatedProducts as De, ProductProvider as Me, filterMediaOnAttributeValues as et, useProductSpecificationGroup as La, useProductAttribute as $, useProductPurchaseStatus as Ie, useProductOptions as He, useProductSiblings as tt, useBundleOptions as Ke, useBundleItemId as za, useBundlePurchaseStatus as xa, useProductHasOptionsInStock as Ra } from "@made-people/grease-product";
import { useTranslate as L } from "@made-people/grease-translations";
import Ea from "clsx";
import { accordionItemSchema as Wa, accordionSchema as Ga, Accordion as Oa } from "@made-people/blueprint-accordion";
import { useKeenSlider as Ze } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as oe, responsiveImageSchema as at } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as ja } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as Ma, ResponsiveVideo as nt } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as ot } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as st, Badge as Ce } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as Ha, useUpdateCart as Le, useCartMethod as Ka } from "@made-people/grease-cart";
import { uiEventEmitter as Va } from "@made-people/grease-ui-events";
import { Heading as $a } from "@made-people/blueprint-heading";
import { isNotUndefined as Ua } from "@made-people/typeguards-common";
import { motion as ae, AnimatePresence as pe, cubicBezier as it } from "motion/react";
import { linkAsLinkSchema as Fa, Link as Ya, LinkAsLink as Xa, linkAsButtonSchema as Qa, LinkAsButton as Za } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as me, ButtonAsButton as Pe, Button as ie, buttonAsButtonSchema as Oe, ButtonAsSpan as rt, buttonAsSpanSchema as qa } from "@made-people/blueprint-button";
import { toast as Ja } from "sonner";
import { productCardSchema as en, ProductCard as tn } from "@made-people/blueprint-product-card";
import { SearchResultProvider as lt, useSearchResultItems as an } from "@made-people/grease-search";
import { swipeableProductListSchema as ct, SwipeableProductList as nn } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as on } from "@made-people/blueprint-markdown";
import { GridContext as sn } from "@made-people/blueprint-grid";
import { Breadcrumbs as re, breadcrumbsSchema as rn } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as ln, ShippingBarometer as cn } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as dt } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as dn } from "@made-people/blueprint-icons";
import { useLink as un } from "@made-people/grease-link";
import "@made-people/blueprint";
const pn = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), mn = ({
  children: a,
  CloseIcon: o,
  slots: n
}) => {
  const { isOpen: s, onChange: i } = Da();
  return F(() => {
    i(!0);
  }, []), /* @__PURE__ */ e(de.Root, { defaultOpen: !0, onOpenChange: i, open: s, children: /* @__PURE__ */ p(de.Portal, { children: [
    /* @__PURE__ */ e(de.Overlay, { className: n.modalOverlay }),
    /* @__PURE__ */ p(
      de.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: n.modalContent,
        children: [
          /* @__PURE__ */ e(de.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(de.Close, { className: n.closeButton, children: o }),
          /* @__PURE__ */ e("section", { className: n.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, ut = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), hn = P(
  "ProductDrawer",
  y(
    ut,
    ({ variants: a, children: o, closeIcon: n = pn, drawerSettings: s }) => {
      const i = Zt.styles(a), [c, r] = U(!1);
      F(() => {
        r(window.innerWidth > 1124);
      }, []);
      const l = () => typeof n == "string" || Xt(n) ? n : typeof n == "function" ? /* @__PURE__ */ e(n, {}) : null;
      return c ? /* @__PURE__ */ e(mn, { CloseIcon: l(), slots: i, children: o }) : /* @__PURE__ */ e(
        M,
        {
          ...s,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...s == null ? void 0 : s.variants
          },
          children: /* @__PURE__ */ p(
            M.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(M.Close, { className: i.closeButton, children: l() }),
                /* @__PURE__ */ e(M.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: i.drawerWrapper, children: /* @__PURE__ */ e("section", { className: i.contentWrapper, children: o }) })
              ]
            }
          )
        }
      );
    }
  )
), pt = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), bn = P(
  "ProductGrid",
  y(pt, ({ variants: a, children: o }) => {
    const n = qt.styles(a);
    return /* @__PURE__ */ e("section", { className: n.base, children: o });
  })
), gn = t.discriminatedUnion("template", [
  ut,
  pt
]), fn = P(
  "ProductRoot",
  y(gn, (a) => a.template === "drawer" ? /* @__PURE__ */ e(hn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(bn, { ...a }) : null)
), mt = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), vn = P(
  "ProductDetailsName",
  y(
    {
      schema: mt,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: o, headingTag: n, asLink: s, ...i }) => {
      const c = j(), {
        content: { name: r }
      } = c, d = (i.blueprint ?? ee.main).styles(a), h = n ?? "h1", g = o ?? r;
      return s ? /* @__PURE__ */ e(h, { className: d.name, children: /* @__PURE__ */ e(Se, { productBase: c, context: "product-card", children: g }) }) : /* @__PURE__ */ e(h, { className: d.name, children: g });
    }
  )
), Pn = t.object({
  variants: t.custom().optional()
}), yn = P(
  "ProductDetailsShortDescription",
  y(Pn, ({ variants: a }) => {
    const {
      content: { shortDescription: o }
    } = j(), n = ee.main.styles(a);
    return o ? /* @__PURE__ */ e("p", { className: n.shortDescription, children: o }) : null;
  })
), Ve = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), Sn = P(
  "ProductDetailsDescription",
  y(
    Ve,
    ({
      variants: a,
      readMoreSettings: o,
      text: n,
      label: s,
      formatDotsToList: i,
      ...c
    }) => {
      const {
        content: { description: r }
      } = j(), d = (c.blueprint ?? ee.main).styles(a), [h, g] = U(!(o != null && o.enabled)), f = L();
      if (!r && !n)
        return null;
      const _ = n ?? r, w = _.length > ((o == null ? void 0 : o.limit) ?? 200), b = i ? _.split(`
`).map((v) => {
        const S = v.trim();
        return S.startsWith("•") ? `<li>${S.substring(1).trim()}</li>` : S ? `${S}` : "";
      }).join("") : _;
      return /* @__PURE__ */ p("div", { className: d.description, children: [
        s && /* @__PURE__ */ e("h2", { className: d.descriptionLabel, children: s }),
        /* @__PURE__ */ e(
          "p",
          {
            className: h ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: h ? b : `${b.substring(0, 200)}...`
            }
          }
        ),
        (o == null ? void 0 : o.enabled) && w && /* @__PURE__ */ e(
          "button",
          {
            className: d.descriptionReadMoreButton,
            onClick: () => g(!h),
            children: f(h ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), wn = t.object({
  variants: t.custom().optional()
}), _n = P(
  "ProductDetailsBrand",
  y(wn, ({ variants: a }) => {
    var c;
    const o = j(), n = ee.main.styles(a), i = (c = ne(o)("brandName", t.string())) == null ? void 0 : c.value;
    return i ? /* @__PURE__ */ e("span", { className: n.brand, children: i }) : null;
  })
), ht = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), kn = 1024, Nn = P(
  "PriceHistoryDrawer",
  y(ht, (a) => {
    var h, g;
    const o = Jt.styles(), n = be(), [s, i] = U(!1), c = L(), r = (h = n.previouslyDiscountedPrices) == null ? void 0 : h.find(
      (f) => f.periodDays === 30
    ), l = n.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if (F(() => {
      const f = () => {
        i(window.innerWidth > kn);
      };
      return window.addEventListener("resize", f), f(), () => {
        window.removeEventListener("resize", f);
      };
    }, []), !a.isEnabled)
      return null;
    const d = (g = n.discountInfo) != null && g.percent ? `(-${n.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ p(
      M,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: c("Price_History_Heading")
          }
        },
        hasHandle: !s,
        variants: {
          dragHandle: s ? "false" : "true",
          rounded: s ? "none" : "strong",
          background: "white",
          direction: s ? "right" : "bottom"
        },
        direction: s ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          l && /* @__PURE__ */ p(M.Trigger, { className: o.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(M.Content, { children: /* @__PURE__ */ p("div", { className: o.contentWrapper, children: [
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.price.formatted }),
              d && /* @__PURE__ */ e("span", { className: o.discountBadge, children: c("Price_History_Current_Price", {
                discountPercent: d
              }) })
            ] }),
            r && /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ p("div", { className: o.priceRow, children: [
              /* @__PURE__ */ e("span", { className: o.priceValue, children: n.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: o.priceLabel, children: c("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), bt = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: ht.optional()
}), Tn = P(
  "ProductDetailsPrice",
  y(bt, ({ variants: a, ...o }) => {
    const n = be(), i = (o.blueprint ?? ee.main).styles(a), c = J(), r = n.price.number < n.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(q, { children: /* @__PURE__ */ p("div", { className: i.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          "data-discount-but-no-campaign": n.discountButNoCampaign ? "true" : "false",
          className: i.price,
          children: n.price.formatted
        }
      ),
      r && /* @__PURE__ */ p("span", { className: i.oldPrice, children: [
        n.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          m.PriceHistoryDrawer,
          {
            ...o.priceHistoryDrawerSettings
          }
        )
      ] }),
      c === "bundle" && /* @__PURE__ */ e(Cn, {})
    ] }) });
  })
), Cn = () => (Be(), null), An = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), Bn = P(
  "ProductDetailsWrapper",
  y(An, ({ variants: a, children: o }) => {
    const n = ee.main.styles(a);
    return /* @__PURE__ */ e("section", { className: n.wrapper, children: o });
  })
), he = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), Dn = P(
  "ProductDetailsProductType",
  y(
    {
      schema: he,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: o, className: n, label: s }) => {
      var d;
      const i = j(), r = (d = ne(i)(
        o ?? "",
        t.string()
      )) == null ? void 0 : d.value, l = ee.main.styles(a);
      if (!(!r && !s))
        return /* @__PURE__ */ e("span", { className: Ea(l.productType, n), children: s ?? r });
    }
  )
), $e = Wa.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), In = t.object({
  variants: t.custom().optional(),
  items: t.array($e).optional(),
  settings: Ga.omit({ items: !0 }).optional()
}), Ln = P(
  "ProductDetailsAccordion",
  y(In, ({ variants: a, items: o, settings: n }) => {
    const s = j(), i = ne(s), c = ee.main.styles(a), r = o == null ? void 0 : o.map((l) => {
      var h;
      let d = l.content.content;
      if (l.content.attributeKey) {
        const g = (h = i(
          l.content.attributeKey,
          t.string()
        )) == null ? void 0 : h.value;
        if (!d && !g)
          return null;
        d = g ?? d;
      }
      return d ? {
        ...l,
        content: {
          content: d,
          value: l.content.value,
          trigger: l.content.trigger,
          forceMount: l.content.forceMount
        }
      } : null;
    }).filter((l) => l !== null);
    return r ? /* @__PURE__ */ e("div", { className: c.accordionWrapper, children: /* @__PURE__ */ e(
      Oa,
      {
        ...n,
        blueprint: ee.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), zn = {
  Name: vn,
  ShortDescription: yn,
  Brand: _n,
  Price: Tn,
  Wrapper: Bn,
  Description: Sn,
  ProductType: Dn,
  Accordion: Ln
  // Add other components as needed
}, xn = t.object({
  className: t.string().optional(),
  badgeSettings: st.optional(),
  hide: t.boolean().optional()
}), Rn = ({
  badgeSettings: a,
  hide: o,
  className: n
}) => {
  const s = L(), i = Be(), c = i.discountFromPriceOfItemsOutsideBundle.formatted, r = i.discountFromPriceOfItemsOutsideBundle.number;
  return o || !c || r <= 0 ? null : /* @__PURE__ */ e("div", { className: n, children: /* @__PURE__ */ e(
    Ce,
    {
      ...a,
      label: s("PDP_Bundle_Savings_Badge", { bundleSavings: c })
    }
  ) });
}, gt = P(
  "BundleSavingsBadge",
  y(xn, (a) => J() !== "bundle" ? null : /* @__PURE__ */ e(Rn, { ...a }))
), En = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), Wn = P(
  "ShopTheLookItem",
  y(
    {
      schema: En,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: o }) => {
      var f;
      const n = j(), s = Ia(), i = be(), c = J(), r = ne(n), l = ea.styles(o), d = s == null ? void 0 : s[0], h = i.price.number < i.priceWithoutDiscount.number, g = a ? (f = r(a, t.string())) == null ? void 0 : f.value : void 0;
      return /* @__PURE__ */ p("div", { className: l.wrapper, children: [
        /* @__PURE__ */ p("div", { className: l.contentWrapper, children: [
          d && /* @__PURE__ */ e(
            Se,
            {
              productBase: n,
              context: "product-card",
              className: l.imageWrapper,
              children: /* @__PURE__ */ e(oe, { className: l.image, image: d })
            }
          ),
          /* @__PURE__ */ p("div", { className: l.info, children: [
            /* @__PURE__ */ e("h4", { className: l.productName, children: n.content.name }),
            g && /* @__PURE__ */ e("p", { className: l.productType, children: g }),
            /* @__PURE__ */ p("div", { className: l.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": h ? "true" : "false",
                  className: l.price,
                  children: i.price.formatted
                }
              ),
              h && /* @__PURE__ */ e("span", { className: l.priceBeforeDiscount, children: i.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        c === "with_variants" && /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          m.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), Ue = "shop_the_look", Gn = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), On = () => {
  const [a, o] = U(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return F(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, ft = P(
  "ShopTheLook",
  y(
    {
      schema: Gn,
      defaultProps: {}
    },
    ({
      media: a,
      className: o = "",
      variants: n,
      drawerSettings: s,
      closeIcon: i,
      triggerIcon: c,
      showProductCountAsSuffix: r
    }) => {
      const [l, d] = U(!1), h = On(), g = je(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), f = (a == null ? void 0 : a.type) === "image" && g(Ue, t.boolean()), _ = ta.styles(n), w = De("look"), b = L();
      if (!f || f.value !== !0 || !w.length)
        return null;
      const v = () => {
        Va.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ p(
        M,
        {
          open: l,
          onOpenChange: d,
          direction: h ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...s,
          children: [
            /* @__PURE__ */ e(
              M.Trigger,
              {
                className: o || _.trigger,
                onClick: v,
                "aria-label": `Shop The Look - ${w.length} ${w.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ p("div", { className: _.triggerContent, children: [
                  b("Shop_The_Look_Trigger"),
                  c
                ] })
              }
            ),
            /* @__PURE__ */ p(M.Content, { children: [
              /* @__PURE__ */ e(M.Title, { hidden: !0, children: b("Shop_The_Look_Heading") }),
              /* @__PURE__ */ p("div", { className: _.wrapper, children: [
                /* @__PURE__ */ p("div", { className: _.header, children: [
                  /* @__PURE__ */ e(
                    $a,
                    {
                      heading: b("Shop_The_Look_Heading"),
                      suffix: r ? String(w.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(M.Close, { className: _.close, children: i ?? b("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: _.productList, children: w.map((S, A) => /* @__PURE__ */ e(
                  Ha,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      Me,
                      {
                        product: S.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: A
                        },
                        children: /* @__PURE__ */ e(Wn, {})
                      }
                    )
                  },
                  S.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), vt = {
  mobile: "150vw",
  tablet: "150vw",
  desktop: "100vw"
}, qe = 60, jn = 300, Mn = 30, Hn = 10, Kn = 500, Ee = (a, o, n) => Math.max(o, Math.min(n, a)), Je = (a, o) => Math.hypot(a.clientX - o.clientX, a.clientY - o.clientY);
function Pt({
  enabled: a = !1,
  maxScale: o = 2.5,
  onZoomChange: n,
  onSwipeAtEdge: s,
  hideCursor: i = !1,
  resetOnMouseLeave: c = !1
} = {}) {
  const [r, l] = O.useState(
    null
  ), d = O.useRef(null), h = O.useRef(null), [g, f] = O.useState(!1), [_, w] = O.useState(!1), [b, v] = O.useState(!1), S = O.useRef({ onZoomChange: n, onSwipeAtEdge: s });
  S.current = { onZoomChange: n, onSwipeAtEdge: s };
  const A = O.useRef({
    scale: 1,
    tx: 0,
    ty: 0,
    gesture: { type: "idle" },
    rect: null,
    pinchAnchor: null,
    zoomedFlag: !1,
    lastTapAt: 0,
    lastTapX: 0,
    lastTapY: 0,
    lastTouchEndAt: 0,
    tapStartX: 0,
    tapStartY: 0
  }), N = O.useCallback(() => {
    var R, G;
    const u = A.current;
    u.gesture = { type: "idle" }, u.scale = 1, u.tx = 0, u.ty = 0;
    const x = d.current;
    x && (x.style.transition = "transform 250ms", x.style.transform = "translate(0px, 0px) scale(1)"), u.zoomedFlag && (u.zoomedFlag = !1, f(!1), (G = (R = S.current).onZoomChange) == null || G.call(R, !1));
  }, []);
  O.useEffect(() => {
    if (!a || !r)
      return;
    const u = A.current, x = () => {
      u.rect = r.getBoundingClientRect();
    }, R = (k) => {
      const D = d.current;
      D && (u.rect && (u.tx = Ee(u.tx, u.rect.width * (1 - u.scale), 0), u.ty = Ee(u.ty, u.rect.height * (1 - u.scale), 0)), D.style.transition = k ? "transform 250ms" : "none", D.style.transform = `translate(${u.tx}px, ${u.ty}px) scale(${u.scale})`);
    }, G = (k) => {
      var D, T;
      u.zoomedFlag !== k && (u.zoomedFlag = k, k && w(!0), f(k), (T = (D = S.current).onZoomChange) == null || T.call(D, k));
    }, V = (k, D, T, K) => {
      if (!u.rect)
        return;
      const se = k - u.rect.left, ce = D - u.rect.top;
      u.scale = T, u.tx = -se * (T - 1), u.ty = -ce * (T - 1), R(K);
    }, Y = (k, D) => {
      const T = h.current;
      !T || !u.rect || (T.style.transform = `translate(${k - u.rect.left}px, ${D - u.rect.top}px) translate(-50%, -50%)`);
    };
    x();
    const X = (k) => {
      x();
      const D = u.rect;
      if (!D)
        return;
      const T = k.touches[0], K = k.touches[1];
      k.touches.length === 2 && T && K ? (k.preventDefault(), k.stopPropagation(), u.pinchAnchor || (u.pinchAnchor = { scale: u.scale, tx: u.tx, ty: u.ty }), u.gesture = {
        type: "pinch",
        startDist: Je(T, K),
        startScale: u.scale,
        startTx: u.tx,
        startTy: u.ty,
        anchorX: (T.clientX + K.clientX) / 2 - D.left,
        anchorY: (T.clientY + K.clientY) / 2 - D.top
      }) : k.touches.length === 1 && T && u.scale > 1 ? (k.preventDefault(), k.stopPropagation(), u.gesture = {
        type: "pan",
        startX: T.clientX,
        startY: T.clientY,
        startTx: u.tx,
        startTy: u.ty
      }, u.tapStartX = T.clientX, u.tapStartY = T.clientY) : (u.gesture = { type: "idle" }, T && (u.tapStartX = T.clientX, u.tapStartY = T.clientY));
    }, C = (k) => {
      var se, ce, ke, Qe;
      const D = u.gesture;
      if (D.type === "idle")
        return;
      k.preventDefault(), k.stopPropagation();
      const T = k.touches[0], K = k.touches[1];
      if (D.type === "pinch" && T && K && D.startDist > 0) {
        const fe = Je(T, K) / D.startDist, Ne = Ee(D.startScale * fe, 1, o), Te = Ne / D.startScale;
        u.scale = Ne, u.tx = D.anchorX - (D.anchorX - D.startTx) * Te, u.ty = D.anchorY - (D.anchorY - D.startTy) * Te, R(!1);
      } else if (D.type === "pan" && T) {
        const fe = D.startTx + (T.clientX - D.startX), Ne = D.startTy + (T.clientY - D.startY);
        if (u.tx = fe, u.ty = Ne, R(!1), u.rect && u.scale > 1) {
          const Te = u.rect.width * (1 - u.scale);
          if (fe > qe) {
            (ce = (se = S.current).onSwipeAtEdge) == null || ce.call(se, "prev"), N();
            return;
          }
          if (fe < Te - qe) {
            (Qe = (ke = S.current).onSwipeAtEdge) == null || Qe.call(ke, "next"), N();
            return;
          }
        }
      }
    }, I = (k) => {
      const D = u.gesture;
      if (k.touches.length === 0) {
        if (u.lastTouchEndAt = Date.now(), u.pinchAnchor) {
          const K = u.pinchAnchor;
          u.pinchAnchor = null, u.gesture = { type: "idle" }, u.scale = K.scale, u.tx = K.tx, u.ty = K.ty, R(!0), G(K.scale > 1);
          return;
        }
        const T = k.changedTouches[0];
        if (T && (D.type === "pan" || D.type === "idle") && Math.hypot(
          T.clientX - u.tapStartX,
          T.clientY - u.tapStartY
        ) < Hn) {
          const se = Date.now(), ce = se - u.lastTapAt, ke = Math.hypot(
            T.clientX - u.lastTapX,
            T.clientY - u.lastTapY
          );
          ce < jn && ke < Mn ? (u.lastTapAt = 0, u.scale > 1 ? N() : (V(T.clientX, T.clientY, o, !0), G(!0))) : (u.lastTapAt = se, u.lastTapX = T.clientX, u.lastTapY = T.clientY), u.gesture = { type: "idle" };
          return;
        }
        G(u.scale > 1), u.gesture = { type: "idle" };
      } else if (k.touches.length === 1 && D.type === "pinch") {
        const T = k.touches[0];
        u.scale > 1 && T ? u.gesture = {
          type: "pan",
          startX: T.clientX,
          startY: T.clientY,
          startTx: u.tx,
          startTy: u.ty
        } : u.gesture = { type: "idle" };
      }
    }, Z = (k) => {
      Date.now() - u.lastTouchEndAt < Kn || (u.scale > 1 ? N() : (V(k.clientX, k.clientY, o, !0), G(!0)));
    }, te = (k) => {
      Y(k.clientX, k.clientY), !(u.scale <= 1) && V(k.clientX, k.clientY, u.scale, !1);
    }, Q = (k) => {
      x(), Y(k.clientX, k.clientY), v(!0);
    }, H = () => {
      v(!1), c && N();
    };
    return r.addEventListener("touchstart", X, {
      passive: !1
    }), r.addEventListener("touchmove", C, { passive: !1 }), r.addEventListener("touchend", I, { passive: !1 }), r.addEventListener("touchcancel", I, { passive: !1 }), r.addEventListener("click", Z), r.addEventListener("mousemove", te), r.addEventListener("mouseenter", Q), r.addEventListener("mouseleave", H), window.addEventListener("resize", x), window.addEventListener("scroll", x, {
      passive: !0,
      capture: !0
    }), () => {
      r.removeEventListener("touchstart", X), r.removeEventListener("touchmove", C), r.removeEventListener("touchend", I), r.removeEventListener("touchcancel", I), r.removeEventListener("click", Z), r.removeEventListener("mousemove", te), r.removeEventListener("mouseenter", Q), r.removeEventListener("mouseleave", H), window.removeEventListener("resize", x), window.removeEventListener("scroll", x, { capture: !0 });
    };
  }, [a, r, o, c, N]);
  const E = O.useCallback(
    (u) => {
      a && l(u);
    },
    [a]
  ), B = O.useCallback((u) => {
    d.current = u, u && (u.style.transformOrigin = "0 0", u.style.willChange = "transform", u.style.transform = "translate(0px, 0px) scale(1)");
  }, []), z = O.useCallback((u) => {
    h.current = u;
  }, []);
  return {
    containerRef: E,
    contentRef: B,
    cursorRef: z,
    containerProps: a ? {
      style: {
        touchAction: g ? "none" : "pan-y",
        cursor: i && b ? "none" : void 0
      }
    } : {},
    isZoomed: g,
    hasBeenZoomed: _,
    isHovering: b,
    reset: N
  };
}
const yt = ({
  cursorRef: a,
  Cursor: o,
  isZoomed: n,
  isHovering: s
}) => /* @__PURE__ */ e(
  "div",
  {
    ref: a,
    "aria-hidden": "true",
    className: "absolute left-0 top-0 pointer-events-none will-change-transform",
    children: /* @__PURE__ */ e(o, { isZoomed: n, isHovering: s })
  }
), ze = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: Ma.optional(),
  customComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Vn = P(
  "ImageGalleryAsKeen",
  y(
    ze,
    ({
      variants: a,
      indicator: o,
      navigation: n,
      slidesPerView: s,
      gap: i,
      children: c,
      buttonInSlider: r,
      videoSettings: l,
      customComponent: d,
      zoom: h,
      zoomCursor: g,
      ...f
    }) => {
      var V, Y, X;
      const {
        content: { media: _ }
      } = j(), b = (f.blueprint ?? aa).styles(a), [v, S] = O.useState(0);
      function A(C) {
        return (I) => {
          function Z() {
            I.slides.forEach((H) => {
              H.classList.remove("active");
            });
          }
          function te(H) {
            I.slides[H].classList.add("active");
          }
          function Q() {
            I.slides.forEach((H, k) => {
              H.addEventListener("click", () => {
                C.current && C.current.moveToIdx(k);
              });
            });
          }
          I.on("created", () => {
            C.current && (te(I.track.details.rel), Q(), C.current.on("animationStarted", (H) => {
              Z();
              const k = H.animator.targetIdx || 0;
              te(H.track.absToRel(k)), I.moveToIdx(Math.min(I.track.details.maxIdx, k));
            }));
          });
        };
      }
      const N = et(_, {
        key: ot,
        value: [!1, void 0]
      }), B = (N == null ? void 0 : N.length) === 1, z = O.useMemo(
        () => N.map((C) => C.src).join(","),
        [N]
      ), [W, u] = Ze({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !B,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: B ? 1 : (s == null ? void 0 : s.mobile) ?? 1,
              spacing: (i == null ? void 0 : i.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: B ? 1 : (s == null ? void 0 : s.tablet) ?? 1,
              spacing: (i == null ? void 0 : i.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: B ? 1 : (s == null ? void 0 : s.desktop) ?? 1,
              spacing: (i == null ? void 0 : i.desktop) ?? 20
            }
          }
        },
        slideChanged(C) {
          S(C.track.details.rel);
        }
      });
      O.useEffect(() => {
        S(0);
      }, [z]);
      const [x] = Ze(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [A(u)]
      ), R = ja({
        mobile: (V = n == null ? void 0 : n.enabled) == null ? void 0 : V.mobile,
        tablet: (Y = n == null ? void 0 : n.enabled) == null ? void 0 : Y.tablet,
        desktop: (X = n == null ? void 0 : n.enabled) == null ? void 0 : X.desktop
      }), G = O.useCallback(
        (C) => {
          const I = u.current;
          I && (C === "next" ? I.next() : I.prev());
        },
        []
      );
      return /* @__PURE__ */ p(
        "div",
        {
          className: b.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(gt, { className: b.bundleSavingsBadge }),
            /* @__PURE__ */ p(
              "div",
              {
                ref: W,
                className: `keen-slider ${b.galleryWrapper}`,
                children: [
                  c,
                  N.map((C, I) => C ? /* @__PURE__ */ e(
                    $n,
                    {
                      media: C,
                      position: I,
                      index: I,
                      slots: b,
                      currentSlide: v,
                      videoSettings: l,
                      zoom: h,
                      zoomCursor: g,
                      onSwipeAtEdge: G
                    },
                    `${C.src}-${I}`
                  ) : null),
                  d && d,
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: b.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  o === "number" && /* @__PURE__ */ p("span", { className: b.numberIndicator, children: [
                    "[ ",
                    v + 1,
                    " / ",
                    N.length,
                    " ]"
                  ] }),
                  o === "dots" && /* @__PURE__ */ e("span", { className: b.dotsIndicatorWrapper, children: N.map((C, I) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": v === I ? "true" : "false",
                      onClick: () => {
                        var Z;
                        return (Z = u.current) == null ? void 0 : Z.moveToIdx(I);
                      },
                      className: b.dotsIndicator
                    },
                    I
                  )) }),
                  !B && (n == null ? void 0 : n.prevIcon) && (n == null ? void 0 : n.nextIcon) && /* @__PURE__ */ p("div", { className: b.arrowsWrapper, ...R, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.leftArrow,
                        onClick: () => {
                          var C;
                          return (C = u.current) == null ? void 0 : C.prev();
                        },
                        children: n == null ? void 0 : n.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.rightArrow,
                        onClick: () => {
                          var C;
                          return (C = u.current) == null ? void 0 : C.next();
                        },
                        children: n == null ? void 0 : n.nextIcon
                      }
                    )
                  ] })
                ]
              },
              z
            ),
            N.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: x,
                className: `keen-slider thumbnail ${b.thumbnailWrapper}`,
                children: N.map((C, I) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": v === I ? "true" : "false",
                    className: `keen-slider__slide relative ${b.thumbnail}`,
                    children: C.type === "image" && /* @__PURE__ */ e(
                      oe,
                      {
                        image: { src: C.src, alt: (C == null ? void 0 : C.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${C.src}-${I}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), $n = ({
  currentSlide: a,
  position: o,
  index: n,
  media: s,
  slots: i,
  videoSettings: c,
  zoom: r,
  zoomCursor: l,
  onSwipeAtEdge: d
}) => {
  const h = a !== n, g = je(s), f = s.type === "image" && g("model_is_wearing", t.string()), _ = s.type === "image" && g(Ue, t.boolean()), w = !!r && s.type === "image", {
    containerRef: b,
    contentRef: v,
    cursorRef: S,
    containerProps: A,
    isZoomed: N,
    hasBeenZoomed: E,
    isHovering: B,
    reset: z
  } = Pt({
    enabled: w,
    onSwipeAtEdge: d,
    hideCursor: !!l
  });
  if (O.useEffect(() => {
    a !== n && N && z();
  }, [a, n, N, z]), !s)
    return null;
  const W = s.type === "image" && /* @__PURE__ */ e(
    oe,
    {
      image: { src: s.src, alt: s.alt },
      className: i.image,
      fetchpriority: o < 2 ? "high" : "auto",
      loading: o < 2 ? "eager" : "lazy",
      displaySize: E ? vt : { mobile: "50vw", tablet: "80vw", desktop: "40vw" }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      ref: b,
      ...A,
      "data-is-active": a === n ? "true" : "false",
      className: `keen-slider__slide ${i.imageWrapper} relative`,
      children: [
        s.type !== "image" ? /* @__PURE__ */ e(nt, { src: s.src, loop: !0, autoPlay: !0, ...c }) : w ? /* @__PURE__ */ e("div", { ref: v, className: "w-full h-full", children: W }) : W,
        w && l && /* @__PURE__ */ e(
          yt,
          {
            cursorRef: S,
            Cursor: l,
            isZoomed: N,
            isHovering: B
          }
        ),
        f && /* @__PURE__ */ e("div", { className: i.modelIsWearing, children: f.value }),
        _ && /* @__PURE__ */ e(ft, { media: s, className: i.shopTheLook }),
        h && /* @__PURE__ */ e("div", { className: i.peekingImage })
      ]
    },
    n
  );
}, St = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: at.optional(),
  CustomComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Un = P(
  "ImageGalleryAsGrid",
  y(
    St,
    ({ variants: a, imageSettings: o, CustomComponent: n, zoom: s, zoomCursor: i }) => {
      const {
        content: { media: c }
      } = j(), r = na.styles(a), l = et(c, {
        key: ot,
        value: [!1, void 0]
      });
      return /* @__PURE__ */ p("div", { className: r.base, children: [
        /* @__PURE__ */ e(gt, { className: r.bundleSavingsBadge }),
        l.map(
          (d, h) => d && /* @__PURE__ */ e(
            Fn,
            {
              media: d,
              CustomComponent: n,
              position: h,
              slots: r,
              imageSettings: o,
              amountOfImages: l.length,
              zoom: s,
              zoomCursor: i
            },
            h
          )
        )
      ] });
    }
  )
), Fn = ({
  media: a,
  slots: o,
  position: n,
  amountOfImages: s,
  imageSettings: i,
  CustomComponent: c,
  zoom: r,
  zoomCursor: l
}) => {
  const d = je(a), h = a.type === "image" && d("model_is_wearing", t.string()), g = a.type === "image" && d(Ue, t.boolean()), f = n === s - 1, _ = s % 2 !== 0, w = !!r && a.type === "image", {
    containerRef: b,
    contentRef: v,
    cursorRef: S,
    containerProps: A,
    isZoomed: N,
    hasBeenZoomed: E,
    isHovering: B
  } = Pt({
    enabled: w,
    hideCursor: !!l,
    resetOnMouseLeave: !0
  }), z = a.type === "image" && /* @__PURE__ */ e(
    oe,
    {
      image: { src: a.src, alt: a.alt },
      className: o.image,
      fetchpriority: n < 5 ? "high" : "auto",
      loading: n < 5 ? "eager" : "lazy",
      ...i,
      displaySize: E ? vt : (i == null ? void 0 : i.displaySize) ?? {
        mobile: "90vw",
        tablet: "90vw",
        desktop: _ && f ? "60vw" : "25vw"
      }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      className: o.imageWrapper,
      "data-has-shop-the-look": g ? "true" : "false",
      "data-has-model-is-wearing": h ? "true" : "false",
      "data-position": n,
      children: [
        w ? /* @__PURE__ */ p(
          "div",
          {
            ref: b,
            ...A,
            className: "absolute inset-0 overflow-hidden",
            children: [
              /* @__PURE__ */ e("div", { ref: v, className: "w-full h-full", children: z }),
              l && /* @__PURE__ */ e(
                yt,
                {
                  cursorRef: S,
                  Cursor: l,
                  isZoomed: N,
                  isHovering: B
                }
              )
            ]
          }
        ) : a.type === "image" ? z : /* @__PURE__ */ e(nt, { src: a.src, loop: !0, autoPlay: !0 }),
        h && /* @__PURE__ */ e("div", { className: o.modelIsWearing, children: h.value }),
        g && /* @__PURE__ */ e(ft, { media: a, className: o.shopTheLook }),
        c && /* @__PURE__ */ e(c, { position: n, amountOfImages: s })
      ]
    }
  );
}, wt = t.discriminatedUnion("template", [
  ze,
  St
]), Yn = P(
  "ImageGallery",
  y(wt, (a) => a.template === "keen" ? /* @__PURE__ */ e(Vn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Un, { ...a }) : null)
), _t = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), Xn = P(
  "ProductSpecificationsAsTable",
  y(
    {
      schema: _t,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: o, groupId: n }) => {
      const s = oa.styles(a), i = (o == null ? void 0 : o.headingTag) || "h3", c = La(
        n ?? "pdp_specifications"
      );
      return !c || !c.length ? null : /* @__PURE__ */ p("div", { className: s.base, children: [
        (o == null ? void 0 : o.heading) && /* @__PURE__ */ e(i, { className: s.heading, children: o.heading }),
        /* @__PURE__ */ e("ol", { className: s.tableWrapper, children: c.map((r, l) => /* @__PURE__ */ p("li", { className: s.row, children: [
          /* @__PURE__ */ p("span", { className: s.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: s.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: s.value, children: r.value })
        ] }, l)) })
      ] });
    }
  )
), kt = t.discriminatedUnion("template", [
  _t
]), Qn = P(
  "ProductSpecifications",
  y(kt, (a) => a.template === "table" ? /* @__PURE__ */ e(Xn, { ...a }) : null)
), Zn = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Fe = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Zn.array().optional()
}), qn = P(
  "AttributesAsProgressBar",
  y(
    Fe,
    ({
      variants: a,
      features: o = {
        onAScaleOf: 10
      },
      items: n
    }) => {
      const s = sa.styles(a), i = j(), c = ne(i);
      if (!n)
        return null;
      const r = n.map((l) => {
        var h;
        const d = (h = c(l.attributeKey, t.string())) == null ? void 0 : h.value;
        if (d)
          return {
            label: l.label,
            score: parseInt(d),
            barColor: l.barColor
          };
      }).filter(Ua);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: s.base, children: r.map((l, d) => /* @__PURE__ */ p("div", { className: s.item, children: [
        /* @__PURE__ */ e("div", { className: s.label, children: l.label }),
        /* @__PURE__ */ e("div", { className: s.bar, children: /* @__PURE__ */ e(
          ae.div,
          {
            className: s.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${l.score / o.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: d * 0.16 },
            style: {
              backgroundColor: l.barColor
            }
          }
        ) }),
        /* @__PURE__ */ p("div", { className: s.scoreLabel, children: [
          l.score,
          "/",
          o.onAScaleOf
        ] })
      ] }, d)) });
    }
  )
), qs = t.string(), Ye = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), Jn = P(
  "AttributesAsTags",
  y(Ye, ({ variants: a, attributeKey: o, label: n }) => {
    const s = ia.styles(a), i = $(
      o,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!i)
      return null;
    const c = Array.isArray(i.value) ? i.value : [i.value];
    return c.length ? /* @__PURE__ */ p("div", { className: s.base, children: [
      n && /* @__PURE__ */ e("span", { className: s.label, children: n }),
      /* @__PURE__ */ e("div", { className: s.tags, children: c.map((r, l) => /* @__PURE__ */ e("div", { className: s.tag, children: typeof r == "object" ? r.description : r }, `${r}-${l}`)) })
    ] }) : null;
  })
), Nt = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: Fa.optional()
}), eo = P(
  "AttributesAsIconBlocks",
  y(
    Nt,
    ({ variants: a, attributeKey: o, label: n, link: s }) => {
      var r, l;
      const i = ra.styles(a), c = (r = $(
        o,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (c)
        return /* @__PURE__ */ p("div", { className: i.base, children: [
          /* @__PURE__ */ p("div", { className: i.header, children: [
            n && /* @__PURE__ */ e("span", { className: i.label, children: n }),
            ((l = s == null ? void 0 : s.link) == null ? void 0 : l.href) && /* @__PURE__ */ e(Ya, { as: "a", className: i.link, ...s })
          ] }),
          /* @__PURE__ */ e("div", { className: i.blocks, children: c.map(
            (d, h) => {
              var g;
              return (g = d.image) != null && g.url ? /* @__PURE__ */ p(
                "div",
                {
                  className: i.block,
                  children: [
                    /* @__PURE__ */ e(
                      oe,
                      {
                        className: i.icon,
                        image: {
                          src: d.image.url,
                          alt: d.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: i.description, children: d.description })
                  ]
                },
                `${d.description}-${h}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), Tt = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional().or(t.custom().optional())
  }).optional()
}), Ct = ({
  variants: a,
  content: o
}) => {
  const n = la.styles(a), s = L();
  return /* @__PURE__ */ p("div", { className: n.base, children: [
    o.attributeLabel && /* @__PURE__ */ e("label", { className: n.label, children: s(o.attributeLabel) }),
    /* @__PURE__ */ e("h4", { className: n.value, children: o.value })
  ] });
}, to = ({
  variants: a,
  attributeKey: o,
  data: n
}) => {
  const i = $(o, t.string()) ?? n;
  return i ? /* @__PURE__ */ e(Ct, { variants: a, content: i }) : null;
}, ao = P(
  "AttributesAsRow",
  y(Tt, ({ variants: a, attributeKey: o, data: n }) => o ? /* @__PURE__ */ e(
    to,
    {
      variants: a,
      attributeKey: o,
      data: n
    }
  ) : n ? /* @__PURE__ */ e(Ct, { variants: a, content: n }) : null)
), no = t.discriminatedUnion("template", [
  Fe,
  Ye,
  Nt,
  Tt
]), oo = P(
  "ProductAttributes",
  y(no, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(qn, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(Jn, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(eo, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(ao, { ...a }) : null)
), so = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), io = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), ro = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: me.optional(),
  decreaseButtonSettings: me.optional()
}), lo = P(
  "AddToCartQuanityPickerRow",
  y(
    ro,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: o,
      amount: n,
      decreaseButtonSettings: s,
      increaseButtonSettings: i
    }) => {
      const {
        addToCartMethod: c,
        removeFromCartMethod: r,
        quantityInCart: l,
        isAvailable: d
      } = Le(), h = L();
      function g(f) {
        c.execute(f), a(!0);
      }
      return /* @__PURE__ */ p("div", { className: o.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          Pe,
          {
            ...s,
            disabled: l < n,
            progress: r.loadingState,
            onClick: () => r.execute(n)
          }
        ),
        /* @__PURE__ */ p("div", { className: o.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: o.quantityText, children: n }),
          /* @__PURE__ */ e("span", { className: o.quantityUnit, children: h("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          Pe,
          {
            ...i,
            progress: c.loadingState,
            disabled: !d,
            onClick: () => g(n)
          }
        )
      ] });
    }
  )
), At = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: me.optional(),
    decreaseButtonSettings: me.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), co = P(
  "AddToCartQuantityPicker",
  y(
    {
      schema: At,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(io, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(so, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: o }) => {
      var b;
      const n = be(), s = ca.styles(a), [i, c] = U(!1), r = L(), [l, d] = U(0);
      We(null);
      const {
        addToCartMethod: h,
        removeFromCartMethod: g,
        quantityInCart: f,
        isAvailable: _
      } = Le(), w = () => {
        l && (l > f ? (h.execute(l - f), c(!0)) : l < f && g.execute(f - l));
      };
      return F(() => {
        d(0);
      }, [f]), /* @__PURE__ */ p("div", { className: s.base, children: [
        /* @__PURE__ */ p("div", { className: s.innerWrapper, children: [
          (o == null ? void 0 : o.showPrice) && /* @__PURE__ */ p(q, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: s.priceTag,
                "data-is-discounted": n.discountInfo ? "true" : "false",
                children: n.price.formatted
              }
            ),
            n.discountInfo && /* @__PURE__ */ e("span", { className: s.oldPriceTag, children: n.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: s.currentQuantityWrapper, children: /* @__PURE__ */ p("div", { className: s.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (v) => {
                  v.preventDefault(), w();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (v) => {
                      v.preventDefault(), d(parseInt(v.target.value));
                    },
                    value: l > 0 ? l : "",
                    className: s.currentQuantityInput,
                    placeholder: f.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            l > 0 ? /* @__PURE__ */ e(
              Pe,
              {
                disabled: !_,
                onClick: w,
                className: s.updateButton,
                progress: l > f ? h.loadingState : g.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: s.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: s.quantityPickersWrapper, children: (b = o == null ? void 0 : o.addQuantityOptions) == null ? void 0 : b.map((v, S) => /* @__PURE__ */ e(
            lo,
            {
              increaseButtonSettings: o.increaseButtonSettings,
              decreaseButtonSettings: o.decreaseButtonSettings,
              amount: v,
              slots: s,
              setDisplayGoToCheckoutButton: c
            },
            S
          )) })
        ] }),
        /* @__PURE__ */ e(pe, { children: i && /* @__PURE__ */ e(
          ae.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              ie,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), Bt = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, uo = (a) => {
  const o = Ie(), n = L(), s = o.status === "out-of-stock" && a ? n("Notify_Me_Submit_Label") : n(Bt[o.status]) ?? "PDP_Select_Size";
  return n(s);
}, Dt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: me.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), po = P(
  "AddToCartButton",
  y(
    {
      schema: Dt,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      animateAddToCartLabel: n,
      postAddAction: s,
      isNotifyMeEnabled: i
    }) => {
      const c = da.styles(a), { addToCartMethod: r, isAvailable: l, isOutOfStock: d, isDiscontinued: h } = Le(), g = d && i, f = uo(g), _ = L(), w = typeof window < "u" && window.location.pathname.includes("/checkout"), [b, v] = U(!1), S = Ge(async () => {
        if (!h) {
          if (d && i) {
            ue.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!l) {
            Ja.error(_("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), s === "goToCheckoutButton" && v(!0), s === "showMinicart" && !w && ue.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        d,
        i,
        r,
        s,
        _,
        w
      ]), A = Qt(
        () => n ? /* @__PURE__ */ e(pe, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          ae.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: f
          },
          f
        ) }) : f,
        [n, f]
      );
      return /* @__PURE__ */ p("div", { className: c.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          ie,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...o,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (d || h) && !g
            },
            "aria-disabled": !l && !g ? "true" : "false",
            label: A,
            onClick: S
          }
        ),
        /* @__PURE__ */ e(pe, { initial: !1, children: b && /* @__PURE__ */ e(
          ae.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: it(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              ie,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: _("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), It = t.discriminatedUnion("template", [
  At,
  Dt
]), mo = P(
  "ProductAddToCart",
  y(It, (a) => J() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(po, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(co, { ...a }) : null)
), we = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Display a component to indicate low stock
     */
    headerContent: t.custom().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), ho = P(
  "SizePickerButtonGrid",
  y(
    we,
    ({ variants: a, notifyMe: o, lowStockIndicator: n, headerContent: s }) => {
      var w;
      const i = ua.styles(a), { optionGroups: c, selectOption: r, selectedOptions: l } = He(), d = L(), h = c.length === 1 && ((w = c[0]) == null ? void 0 : w.options.length) === 1;
      if (h)
        return null;
      F(() => {
        var b;
        h && ((b = c[0]) != null && b.options[0]) && r(
          c[0].dimensionKey,
          c[0].options[0]
        );
      }, []);
      const g = (n == null ? void 0 : n.lowStockLimit) ?? 5, f = (b) => (n == null ? void 0 : n.enabled) === !0 && b.inventory.inStock && b.inventory.quantity < g, _ = c.some(
        (b) => b.options.some(f)
      );
      return /* @__PURE__ */ p("div", { className: i.base, children: [
        /* @__PURE__ */ p("div", { className: i.header, children: [
          /* @__PURE__ */ e("span", { children: d("PDP_Size_Picker_Select_Size") }),
          _ ? n == null ? void 0 : n.headerContent : s
        ] }),
        c.map((b) => /* @__PURE__ */ e("div", { className: i.wrapper, children: b.options.map((v) => {
          var B;
          const S = ((B = l[b.dimensionKey]) == null ? void 0 : B.dimensionValue) === v.dimensionValue, A = v.inventory.inStock, N = f(v), E = () => {
            r(b.dimensionKey, v);
          };
          return /* @__PURE__ */ p(
            "button",
            {
              type: "button",
              "data-is-selected": S ? "true" : "false",
              "data-is-out-of-stock": A ? "false" : "true",
              disabled: !A && !(o != null && o.enabled),
              className: i.size,
              "aria-label": v.label,
              onClick: E,
              children: [
                N && (n == null ? void 0 : n.enabled) && /* @__PURE__ */ e("span", { className: i.lowStockIndicator }),
                (o == null ? void 0 : o.enabled) && !A && o.icon,
                v.label
              ]
            },
            v.dimensionValue
          );
        }) }, b.dimensionKey))
      ] });
    }
  )
), bo = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, go = {
  style: "outline",
  width: "full"
}, ye = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: Oe.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), fo = () => {
  const [a, o] = U(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return F(() => {
    const n = () => {
      o(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, vo = P(
  "SizePickerModal",
  y(
    {
      schema: ye,
      defaultProps: {
        template: "modal",
        drawerSettings: bo,
        buttonVariants: go,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: o,
      buttonVariants: n,
      triggerLabel: s,
      sizeButtons: i,
      aboveButtonComponent: c,
      belowButtonComponent: r,
      customOverlayId: l
    }) => {
      const d = L(), h = fo(), g = pa.styles(a), { optionGroups: f, selectOption: _, selectedOptions: w } = He();
      return /* @__PURE__ */ p(
        M,
        {
          hasOverlay: !0,
          ...o,
          variants: {
            direction: h ? "right" : "bottom",
            ...(o ?? {}).variants
          },
          customOverlayId: l ?? "size-picker-modal",
          direction: h ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(M.Trigger, { className: g.trigger, children: /* @__PURE__ */ e(
              rt,
              {
                label: s ?? d("Size_Picker_Select_Size"),
                variants: n
              }
            ) }),
            /* @__PURE__ */ p(M.Content, { children: [
              /* @__PURE__ */ e("div", { className: g.optionsWrapper, children: f.map((b) => /* @__PURE__ */ p(
                "div",
                {
                  className: g.wrapper,
                  "data-dimension-key": b.dimensionKey,
                  "data-dimension-label": b.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: g.header, children: /* @__PURE__ */ e("h3", { className: g.heading, children: d(`Size_Picker_${b.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: g.sizeWrapper, children: b.options.map((v, S) => {
                      var N;
                      const A = ((N = w[b.dimensionKey]) == null ? void 0 : N.dimensionValue) === v.dimensionValue;
                      return /* @__PURE__ */ e(
                        Pe,
                        {
                          dataAttr: {
                            "is-selected": A,
                            "is-out-of-stock": !v.inventory.inStock
                          },
                          className: g.size,
                          onClick: () => _(b.dimensionKey, v),
                          label: v.label,
                          ...i
                        },
                        `${v.label}-${S}`
                      );
                    }) })
                  ]
                },
                b.dimensionKey
              )) }),
              c,
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), Po = t.discriminatedUnion("template", [
  we,
  ye
]), yo = P(
  "ProductSizePicker",
  y(Po, (a) => J() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(ho, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(vo, { ...a }) : null)
), Xe = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  maxVisible: t.number().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional(),
  hideWhenSingle: t.boolean().optional()
}), So = P(
  "SiblingsImageCard",
  y(
    {
      schema: Xe,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({
      variants: a,
      colorAttributeKey: o,
      headingTag: n,
      maxVisible: s,
      hideWhenSingle: i
    }) => {
      const c = L(), [r, l] = U(!1), d = ma.styles(a), h = $(
        o ?? "",
        t.string()
      ), g = j(), f = tt(), _ = n ?? "h2";
      if (!f.length || i && f.length === 1)
        return null;
      const w = s !== void 0 && f.length > s ? f.length - s : 0;
      return /* @__PURE__ */ p("div", { className: d.base, children: [
        h && /* @__PURE__ */ e(_, { className: d.header, children: c("PDP_Siblings_Header_Title", {
          color: h.value,
          colorName: h.valueLabel
        }) }),
        /* @__PURE__ */ p("div", { className: d.siblingsWrapper, children: [
          f.map((b, v) => {
            var S, A, N, E, B, z;
            return (N = (A = (S = b.content) == null ? void 0 : S.media) == null ? void 0 : A[0]) != null && N.src ? /* @__PURE__ */ e(
              Se,
              {
                productBase: b,
                context: "product-sibling",
                className: d.sibling,
                "data-is-selected": b.productId === g.productId,
                "data-is-overflow": !r && s !== void 0 && v >= s,
                children: /* @__PURE__ */ e(
                  oe,
                  {
                    image: { src: (z = (B = (E = b.content) == null ? void 0 : E.media) == null ? void 0 : B[0]) == null ? void 0 : z.src },
                    displaySize: {
                      mobile: "80px",
                      tablet: "80px",
                      desktop: "80px"
                    },
                    className: d.siblingImage
                  }
                )
              },
              v
            ) : null;
          }),
          w > 0 && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => l((b) => !b),
              className: d.overflowToggle,
              children: r ? c("PDP_Siblings_Show_Less") : c("PDP_Siblings_Show_More", {
                count: w
              })
            }
          )
        ] })
      ] });
    }
  )
), wo = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), _o = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), ko = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), No = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), Lt = ({
  sibling: a,
  colorSwatchAttributeKey: o,
  className: n
}) => {
  const s = j(), i = ne(a);
  if (!o)
    return null;
  const c = i(
    o,
    t.string()
  );
  if (!(c != null && c.valueLabel))
    return null;
  const r = c.valueLabel, l = c.value, d = () => l ? No(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : wo(l) || _o(l) || ko(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {}, h = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    Se,
    {
      productBase: a,
      context: "product-sibling",
      className: n,
      style: d(),
      "data-is-selected": s.productId === a.productId,
      "data-is-white": l === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": h,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, zt = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), To = P(
  "SiblingColorSwatchList",
  y(
    {
      schema: zt,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: o }) => {
      const n = ha.styles(a), s = j(), i = L(), c = tt(), r = ne(s);
      if (!o || !c.length)
        return null;
      const l = r(
        o,
        t.string()
      );
      return l ? /* @__PURE__ */ p("div", { className: n.base, children: [
        /* @__PURE__ */ e("div", { className: n.header, children: i("PDP_Product_ColorSwatch_Label", {
          color: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: n.siblingsWrapper, children: c.map((d, h) => /* @__PURE__ */ e(
          Lt,
          {
            sibling: d,
            colorSwatchAttributeKey: o,
            className: n.sibling
          },
          `sibling.productKey-${h}`
        )) })
      ] }) : null;
    }
  )
), _e = t.discriminatedUnion("template", [
  Xe,
  zt
]), Co = P(
  "ProductSiblings",
  y(_e, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(So, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(To, { ...a }) : null)
), xt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional(),
  productCardSettings: en.optional()
}), Ao = (a) => {
  const o = an(), n = L();
  if (!o || o.length === 0)
    return null;
  const s = ba.styles();
  return /* @__PURE__ */ p("div", { className: s.base, children: [
    /* @__PURE__ */ e("h3", { className: s.heading, children: n("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: s.wrapper, children: o.slice(0, 3).map((i, c) => i.type !== "product" ? null : /* @__PURE__ */ e(
      Me,
      {
        product: i.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: c
        },
        children: /* @__PURE__ */ e(tn, { templateProps: a.productCardSettings })
      },
      c
    )) })
  ] });
}, Rt = P(
  "ProductRelatedProductsImageCards",
  y(xt, ({ relationType: a, ...o }) => {
    const n = De(a);
    if (!Rt.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(Ao, { ...o }) });
  })
), Et = t.object({
  template: t.literal("swiper"),
  swiperSettings: ct.optional(),
  relationType: t.string().optional()
}), Bo = P(
  "ProductRelatedProductsSwiper",
  y(Et, ({ swiperSettings: a, relationType: o }) => {
    const n = De(o);
    if (!n.length)
      return null;
    const s = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(lt, { result: s, children: /* @__PURE__ */ e(nn, { ...a }) });
  })
), le = t.discriminatedUnion("template", [
  xt,
  Et
]), Do = P(
  "RelatedProducts",
  y(le, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(Rt, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(Bo, { ...a }) : null)
), Io = ({
  targetSelector: a,
  mode: o = "isNotVisible"
}) => {
  const [n, s] = U(!1), i = We(null), c = We(null);
  F(() => {
    if (o === "isAlwaysVisible") {
      s(!0);
      return;
    } else if (o === "isAlwaysHidden") {
      s(!1);
      return;
    }
  }, [o]);
  const r = Ge(() => {
    if (!i.current)
      return;
    const d = i.current.getBoundingClientRect();
    switch (o) {
      case "isScrolledPast":
        s(d.bottom <= 0);
        break;
      case "isBeforeView":
        s(d.top >= window.innerHeight);
        break;
    }
  }, [o]), l = Ge(() => {
    c.current && cancelAnimationFrame(c.current), c.current = requestAnimationFrame(() => {
      r(), c.current = null;
    });
  }, [r]);
  return F(() => {
    if (o === "isAlwaysVisible" || o === "isAlwaysHidden" || (i.current = document.querySelector(a), !i.current))
      return;
    let d = null;
    return o === "isVisible" || o === "isNotVisible" ? (d = new IntersectionObserver(
      ([h]) => {
        h && s(
          o === "isVisible" ? h.isIntersecting : !h.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), d.observe(i.current)) : (r(), window.addEventListener("scroll", l, { passive: !0 }), window.addEventListener("resize", l, { passive: !0 })), () => {
      d ? d.disconnect() : (window.removeEventListener("scroll", l), window.removeEventListener("resize", l)), c.current && cancelAnimationFrame(c.current);
    };
  }, [a, o, r, l]), n;
}, Wt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: me.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), Lo = P(
  "StickyAddToCartButton",
  y(
    {
      schema: Wt,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: o,
      mode: n,
      targetSelector: s,
      selectSizeAction: i,
      withSizePicker: c,
      sizePickerOverlayId: r,
      showPrice: l
    }) => {
      const d = ga.styles(a), { addToCartMethod: h, isAvailable: g } = Le(), f = Ie(), _ = L(), { selectedOptions: w } = He(), b = Object.values(w).filter((B) => !!B).map((B) => B.label).join(" / "), v = be(), S = Io({
        targetSelector: s ?? "#add-to-cart-component",
        mode: n
      }), A = typeof window < "u" && window.location.pathname.includes("/checkout"), N = () => {
        ue.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, E = async () => {
        if (!g) {
          if (i === "open-size-picker") {
            N();
            return;
          }
          if (i === "scroll-to-size-picker") {
            const B = document.getElementById("add-to-cart-component");
            B == null || B.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await h.execute(), A || ue.emit("open", { overlayId: "mini-cart" });
      };
      return f.status === "out-of-stock" ? null : c ? /* @__PURE__ */ e(
        "div",
        {
          className: d.base,
          "data-is-visible": S ? "true" : "false",
          children: /* @__PURE__ */ p("div", { className: d.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              ie,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: g ? b : _("PDP_Select_Size"),
                onClick: N
              }
            ),
            /* @__PURE__ */ e(
              ie,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...o,
                progress: h.loadingState,
                label: /* @__PURE__ */ p(q, { children: [
                  _("PDP_Add_To_Cart"),
                  l && /* @__PURE__ */ p(q, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: v.price.formatted })
                  ] })
                ] }),
                onClick: E
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: d.base,
          "data-is-visible": S ? "true" : "false",
          children: /* @__PURE__ */ e(
            ie,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...o,
              progress: h.loadingState,
              label: /* @__PURE__ */ p(q, { children: [
                _(g ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                l && /* @__PURE__ */ p(q, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: v.price.formatted })
                ] })
              ] }),
              onClick: E
            }
          )
        }
      );
    }
  )
), zo = t.discriminatedUnion("template", [
  Wt
]), xo = P(
  "ProductStickyAddToCart",
  y(zo, (a) => J() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(Lo, { ...a }) : null)
), Ro = () => J() !== "bundle" ? null : /* @__PURE__ */ e(Eo, {}), Eo = () => {
  const { sections: a } = Ke(), o = Ae.styles();
  return /* @__PURE__ */ p("div", { className: o.base, children: [
    /* @__PURE__ */ e("div", { className: o.sectionsWrapper, children: Object.values(a).map((n, s) => /* @__PURE__ */ e(
      Me,
      {
        product: n.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: s
        },
        children: /* @__PURE__ */ e(Wo, { section: n, index: s })
      },
      s
    )) }),
    /* @__PURE__ */ e(jo, {}),
    /* @__PURE__ */ e(Mo, {})
  ] });
}, Wo = ({
  section: a,
  index: o
}) => {
  const n = j(), { selectSectionProduct: s } = Ke(), i = Ae.styles(), c = L(), r = (l) => {
    s(a.sectionId, l);
  };
  return /* @__PURE__ */ p("div", { className: i.section, children: [
    /* @__PURE__ */ e(pe, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: i.productNameWrapper, children: /* @__PURE__ */ e(
      ae.h3,
      {
        className: i.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: it(0.32, 0.72, 0, 1)
        },
        children: c("PDP_Bundle_Selection_Product", {
          index: o + 1,
          product: n.content.name
        })
      }
    ) }, n.content.name) }),
    /* @__PURE__ */ e("h3", { className: i.selectionHeading, children: c("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: i.productSlider, children: a.products.map((l, d) => {
      const h = l.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        Go,
        {
          product: l,
          isSelected: h,
          onClick: () => r(l)
        },
        d
      );
    }) }),
    /* @__PURE__ */ e(Oo, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Xa,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: c("PDP_Bundle_Selection_Link"),
        className: i.link
      }
    )
  ] });
}, Go = ({
  product: a,
  isSelected: o,
  onClick: n
}) => {
  var l;
  const s = Ae.styles(), i = (l = a.base.content.media) == null ? void 0 : l[0], r = ne(a.base)("product_color", t.string());
  return /* @__PURE__ */ p(
    "button",
    {
      className: s.productWrapper,
      onClick: n,
      "data-is-selected": o ? "true" : "false",
      children: [
        i && /* @__PURE__ */ e(oe, { className: s.productImage, image: i }),
        r && /* @__PURE__ */ p("div", { className: s.swatchWrapper, children: [
          /* @__PURE__ */ e(
            Lt,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: s.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: s.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, Oo = ({ sectionId: a }) => {
  const o = J(), n = Ie(), { selectSectionSize: s } = Ke(), i = L(), c = n.status === "available" ? n.availableItemId : void 0;
  switch (F(() => {
    s(a, c);
  }, [c]), o) {
    case "with_variants":
      return /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": n.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": n.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: i("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, jo = () => {
  const a = Be(), o = Ae.styles(), n = L();
  return /* @__PURE__ */ p("div", { className: o.totalsWrapper, children: [
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ p("span", { className: o.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ p("div", { className: o.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: o.totalsLabel, children: n("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: o.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, Mo = () => {
  const a = za(), o = xa(), { execute: n } = Ka("addBundleToCart"), [s, i] = O.useState("default"), c = L(), r = async () => {
    if (o.status === "available")
      try {
        i("loading"), await n({
          itemId: a,
          sections: o.sections.map((d) => ({
            sectionId: d.sectionId,
            itemId: d.availableItemId
          }))
        }), await new Promise((d) => setTimeout(d, 1e3)), i("complete"), await new Promise((d) => setTimeout(d, 1e3));
      } catch {
        i("default"), await new Promise((h) => setTimeout(h, 1e3));
      } finally {
        i("default"), ue.emit("open", { overlayId: "mini-cart" });
      }
  }, l = o.status === "available";
  return /* @__PURE__ */ e(
    ie,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: s,
      "aria-disabled": l ? "false" : "true",
      label: c(Bt[o.status]),
      onClick: r
    }
  );
}, ge = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), Ho = P(
  "ProductUspBlock",
  y(
    {
      schema: ge,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: o, attributeKey: n }) => {
      var c, r;
      const s = fa.styles(o), i = (c = $(
        n ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : c.value;
      return !a && !i ? null : /* @__PURE__ */ e("div", { className: s.base, children: (r = a ?? i) == null ? void 0 : r.map((l, d) => /* @__PURE__ */ p("div", { className: s.item, children: [
        l.icon,
        /* @__PURE__ */ e("span", { className: s.label, children: l.label })
      ] }, d)) });
    }
  )
), Gt = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), Ko = P(
  "ProductSizeRecommendationScale",
  y(
    {
      schema: Gt,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      j();
      const o = va.styles(), n = L(), s = $(
        "sizeRecommendation",
        t.string()
      ), i = $(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(i != null && i.value) || !(s != null && s.value)))
        return /* @__PURE__ */ p("div", { className: o.base, children: [
          (i == null ? void 0 : i.value) && i.value && /* @__PURE__ */ p(q, { children: [
            /* @__PURE__ */ e("h3", { className: o.label, children: n("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
              ae.div,
              {
                className: o.dot,
                initial: {
                  left: `${parseInt(i.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ p("div", { className: o.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: o.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (s == null ? void 0 : s.value) && /* @__PURE__ */ e("span", { className: o.sizeText, children: s.value })
        ] });
    }
  )
), Vo = t.discriminatedUnion("template", [
  Gt
]), $o = P(
  "SizeRecommendation",
  y(Vo, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(Ko, { ...a });
  })
), Uo = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: qa.shape.variants.optional()
}), Fo = P(
  "ProductBundleUpsell",
  y(
    {
      schema: Uo,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: o, template: n }) => {
      const s = De("bundle")[0], i = L(), c = Pa.styles(a);
      return s ? /* @__PURE__ */ e(
        Se,
        {
          productBase: s.product.base,
          className: c.base,
          children: n === "button" ? /* @__PURE__ */ e(
            rt,
            {
              label: i("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: s.product.base.content.name
              }),
              variants: o
            }
          ) : /* @__PURE__ */ e("span", { children: i("PDP_Bundle_Upsell_Title", {
            name: s.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), Ot = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: at.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), Yo = P(
  "ProductGiftWithPurchase",
  y(
    {
      schema: Ot,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: o, image: n, variants: s, condition: i }) => {
      var r;
      const c = ya.styles(s);
      return !a && !o && !(n != null && n.image) ? null : /* @__PURE__ */ p("div", { className: c.base, children: [
        /* @__PURE__ */ p("div", { className: c.contentWrapper, children: [
          n && ((r = n.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(oe, { ...n, className: c.image }),
          /* @__PURE__ */ p("div", { className: c.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: c.heading, children: a }),
            o && /* @__PURE__ */ e(on, { content: o, className: c.subtitle })
          ] })
        ] }),
        i && /* @__PURE__ */ e("span", { className: c.condition, children: i })
      ] });
    }
  )
), jt = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), Xo = P(
  "SizeGuideContent",
  y(jt, ({ variants: a, content: o }) => {
    const n = Sa.styles(a);
    return /* @__PURE__ */ e(sn.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: n.contentWrapper, children: o }) });
  })
), Mt = t.object({
  template: t.literal("drawer"),
  contentSettings: jt.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: Oe.optional(),
  closeButtonSettings: Oe.optional()
}), Qo = "cairo", Zo = 1024, qo = P(
  "SizeGuideDrawer",
  y(Mt, (a) => {
    wa.styles(), L();
    const o = a.contentSettings || {
      template: Qo
    };
    if (!a.enabled)
      return null;
    const [n, s] = U(!1);
    return F(() => {
      const i = () => {
        s(window.innerWidth > Zo);
      };
      return window.addEventListener("resize", i), i(), () => {
        window.removeEventListener("resize", i);
      };
    }, []), /* @__PURE__ */ e(
      M,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !n,
        variants: {
          dragHandle: n ? "false" : "true",
          rounded: n ? "none" : "strong",
          background: "white",
          direction: n ? "right" : "bottom"
        },
        direction: n ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(M.Content, { children: /* @__PURE__ */ e(Xo, { ...o }) })
      }
    );
  })
), xe = t.discriminatedUnion("template", [
  Mt
]), Jo = P(
  "SizeGuide",
  y(xe, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(qo, { ...a });
      default:
        return null;
    }
  })
), Re = t.object({
  link: Qa.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), es = P(
  "SizeGuideTrigger",
  y(Re, ({ variants: a, label: o, link: n, icon: s }) => {
    const i = _a.styles(a);
    return /* @__PURE__ */ e(
      Za,
      {
        onClick: () => ue.emit("open", { overlayId: "size-guide" }),
        className: i.trigger,
        label: o,
        icon: s,
        ...n
      }
    );
  })
), ts = t.object({
  variants: t.custom().optional()
}), as = ({ variants: a }) => {
  const o = L(), n = ka.styles(a), s = Be(), i = s.discountFromPriceOfItemsOutsideBundle.formatted, c = s.discountFromPriceOfItemsOutsideBundle.number;
  return !i || c <= 0 ? null : /* @__PURE__ */ p("div", { className: n.base, children: [
    /* @__PURE__ */ e("h3", { className: n.heading, children: o("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: i
    }) }),
    /* @__PURE__ */ e("p", { className: n.text, children: o("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, ns = P(
  "ProductBundlePromoBanner",
  y(
    {
      schema: ts,
      defaultProps: {}
    },
    (a) => J() !== "bundle" ? null : /* @__PURE__ */ e(as, { ...a })
  )
), m = {
  SizeGuide: Jo,
  Details: zn,
  Root: fn,
  ImageGallery: Yn,
  AddToCart: mo,
  Specifications: Qn,
  Attributes: oo,
  SizePicker: yo,
  Siblings: Co,
  RelatedProducts: Do,
  StickyAddToCart: xo,
  Bundle: Ro,
  BundleUpsell: Fo,
  UspBlock: Ho,
  SizeGuideTrigger: es,
  SizeRecommendation: $o,
  GiftWithPurchase: Yo,
  BundlePromoBanner: ns,
  PriceHistoryDrawer: Nn
  // Add other components as needed
}, Ht = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: he.optional(),
  productDesignerSettings: he.optional(),
  relatedProductsSettings: le.optional(),
  sizePickerSettings: we.optional(),
  uspBlockSettings: ge.optional(),
  siblingsPickerSettings: _e.optional(),
  sizeGuideSettings: xe.optional(),
  sizeGuideTriggerSettings: Re.optional(),
  belowTheFoldComponents: t.custom().optional()
}), os = P(
  "ProductTemplateAsBasic",
  y(
    {
      schema: Ht,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      uspBlockSettings: n,
      siblingsPickerSettings: s,
      sizeGuideSettings: i,
      sizeGuideTriggerSettings: c,
      belowTheFoldComponents: r
    }) => {
      var g;
      const l = j(), d = Na.styles(), h = L();
      return /* @__PURE__ */ e(pe, { mode: "wait", children: /* @__PURE__ */ p(
        ae.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: l.productId,
          className: d.base,
          children: [
            /* @__PURE__ */ e(
              re,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: d.detailsWrapper, children: [
              /* @__PURE__ */ e(
                re,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(m.Details.Brand, {}),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...s
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...i }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...c,
                      label: h("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(m.UspBlock, { ...n }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: h("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: d.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                m.Details.Description,
                {
                  label: h("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: h("PDP_Product_Details"),
                        value: "details",
                        content: l.content.description
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: d.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(g = a == null ? void 0 : a.swiperSettings) == null ? void 0 : g.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), Kt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: rn.optional(),
  imageGallerySettings: wt.optional(),
  addToCartSettings: It.optional(),
  descriptionSettings: Ve.optional(),
  specificationSettings: kt.optional(),
  progressBarSettings: Fe.optional(),
  tagsSettings: t.array(Ye).optional(),
  relatedProductsSettings: le.optional(),
  discontinuedBadgeWrapper: st.optional(),
  shippingBarometer: ln.optional(),
  id: t.string().optional()
}), ss = P(
  "ProductPageTemplateHelsinki",
  y(
    {
      schema: Kt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: o,
      addToCartSettings: n,
      descriptionSettings: s,
      specificationSettings: i,
      progressBarSettings: c,
      tagsSettings: r,
      relatedProductsSettings: l,
      discontinuedBadgeWrapper: d,
      shippingBarometer: h,
      id: g
    }) => {
      var b;
      const { status: f } = Ie(), _ = L(), w = Ta.styles();
      return /* @__PURE__ */ p(
        "section",
        {
          id: g,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ p(m.ImageGallery, { ...o, template: "keen", children: [
              /* @__PURE__ */ e(
                re,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              f === "discontinued" && /* @__PURE__ */ e("div", { className: w.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                Ce,
                {
                  label: _("PDP_Discontinued_Badge"),
                  ...d
                }
              ) })
            ] }),
            /* @__PURE__ */ p("div", { className: w.addToCartWrapper, children: [
              /* @__PURE__ */ e(m.Details.Name, {}),
              f === "out-of-stock" && /* @__PURE__ */ p("div", { className: w.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: w.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Out_Of_Stock") })
              ] }),
              f === "discontinued" && /* @__PURE__ */ p("div", { className: w.discontinued, children: [
                /* @__PURE__ */ e("span", { className: w.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: _("PDP_Discontinued_Message") })
              ] }),
              f !== "discontinued" && /* @__PURE__ */ e(
                m.AddToCart,
                {
                  ...n ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                cn,
                {
                  ...h,
                  className: w.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.detailsWrapper, children: [
              /* @__PURE__ */ e(m.Details.ShortDescription, {}),
              /* @__PURE__ */ e(m.Details.Description, { ...s }),
              /* @__PURE__ */ e(
                m.Specifications,
                {
                  ...i ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: w.attributesWrapper, children: [
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  template: "progress-bar",
                  ...c
                }
              ),
              r && /* @__PURE__ */ e("div", { className: w.tags, children: r.map((v, S) => /* @__PURE__ */ e(m.Attributes, { ...v }, S)) })
            ] }),
            /* @__PURE__ */ e("div", { className: w.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(b = l == null ? void 0 : l.swiperSettings) == null ? void 0 : b.settings,
                    headerSettings: {
                      heading: {
                        heading: _("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), Vt = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: he.optional(),
  relatedProductsSettings: le.optional(),
  siblingSettings: Xe.optional(),
  sizePickerSettings: we.optional(),
  uspBlockSettings: ge.optional(),
  giftWithPurchaseSettings: Ot.optional(),
  extendAccordion: t.array($e).optional(),
  sizeGuideSettings: xe.optional(),
  sizeGuideTriggerSettings: Re.optional(),
  priceSettings: bt.optional(),
  priceCalloutSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  sizeFinderSlotPosition: t.enum(["above-atc", "below-atc"]).optional(),
  openFirstAccordionItem: t.boolean().optional(),
  alwaysShowStickyAddToCart: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  bundleUpsell: t.custom().optional(),
  aiSummarySlot: t.custom().optional(),
  accordionRootSettings: t.custom().optional(),
  bundleDisplayStyle: t.enum(["card", "text"]).optional(),
  enableImageGalleryZoom: t.boolean().optional()
}), is = P(
  "ProductTemplateAsMalibu",
  y(
    {
      schema: Vt,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      siblingSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      extendAccordion: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      giftWithPurchaseSettings: d,
      priceSettings: h,
      priceCalloutSlot: g,
      belowTheFoldComponents: f,
      reviewComponentSlot: _,
      accordionRootSettings: w,
      sizeFinderSlot: b,
      bundleUpsell: v,
      sizeFinderSlotPosition: S,
      tagsComponentSlot: A,
      openFirstAccordionItem: N,
      alwaysShowStickyAddToCart: E,
      aiSummarySlot: B,
      bundleDisplayStyle: z,
      enableImageGalleryZoom: W
    }) => {
      var X;
      const u = j(), x = Ca.styles(), R = L(), G = $("fit_text", t.string()), [V, Y] = U(
        void 0
      );
      return F(() => {
        const C = () => Y("reviews");
        return window.addEventListener("pdp:open-reviews", C), () => window.removeEventListener("pdp:open-reviews", C);
      }, []), /* @__PURE__ */ p("section", { className: x.base, children: [
        /* @__PURE__ */ e(dt, { template: "drawer" }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            zoom: W
          }
        ),
        /* @__PURE__ */ e(
          m.StickyAddToCart,
          {
            template: "button",
            mode: E ? "isNotVisible" : "isScrolledPast"
          }
        ),
        /* @__PURE__ */ e(m.ImageGallery, { template: "grid", zoom: W }),
        /* @__PURE__ */ p("section", { className: x.detailsWrapper, children: [
          /* @__PURE__ */ e(
            re,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(
            m.Details.Price,
            {
              ...h,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(dn, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
          g,
          _,
          A,
          /* @__PURE__ */ e(m.Siblings, { template: "image-card", ...n }),
          /* @__PURE__ */ e(
            m.SizePicker,
            {
              template: "button-grid",
              ...s
            }
          ),
          /* @__PURE__ */ e(m.BundlePromoBanner, {}),
          /* @__PURE__ */ e(m.Bundle, {}),
          S !== "below-atc" && b && b,
          /* @__PURE__ */ e(
            m.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (X = s == null ? void 0 : s.notifyMe) == null ? void 0 : X.enabled
            }
          ),
          S === "below-atc" && b && b,
          z === "text" && /* @__PURE__ */ e(m.BundleUpsell, {}),
          (G == null ? void 0 : G.value) && /* @__PURE__ */ e("span", { className: x.fitText, children: G.value }),
          /* @__PURE__ */ e(m.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            m.SizeGuideTrigger,
            {
              ...l,
              label: R("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(m.UspBlock, { ...i }),
          z === "card" && v,
          B,
          /* @__PURE__ */ e(m.GiftWithPurchase, { ...d }),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: R("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: u.content.description
                  }
                },
                {
                  content: {
                    trigger: R("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: R("PDP_Product_Details"),
                    forceMount: !0,
                    content: u.content.shortDescription
                  }
                },
                ...c ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: w ?? {
                    type: "single",
                    value: V,
                    defaultValue: N ? "description" : void 0,
                    onValueChange: (C) => Y(C)
                  }
                }
              }
            }
          )
        ] }),
        f
      ] });
    }
  )
), $t = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: le.optional(),
  sizePickerSettings: ye.optional(),
  sizePicker2Settings: ye.optional(),
  uspBlockSettings: ge.optional(),
  imageGallerySettings: ze.optional(),
  siblingsPickerSettings: _e.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional(),
  washingInstructionDrawer: t.custom().optional(),
  discountBadge: t.object({
    enabled: t.boolean().optional(),
    variants: t.custom().optional()
  }).optional()
}), rs = () => /* @__PURE__ */ e(m.AddToCart, { template: "button" }), ls = ({
  sizePickerSettings: a,
  sizePicker2Settings: o
}) => {
  const n = L(), s = Ra();
  return /* @__PURE__ */ e(q, { children: s ? /* @__PURE__ */ p(q, { children: [
    /* @__PURE__ */ e(m.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      m.SizePicker,
      {
        ...o,
        template: "modal",
        triggerLabel: n("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    Pe,
    {
      label: n("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, cs = P(
  "ProductTemplateAsVienna",
  y(
    {
      schema: $t,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: o,
      sizePicker2Settings: n,
      uspBlockSettings: s,
      imageGallerySettings: i,
      siblingsPickerSettings: c,
      detailsComponentSlot: r,
      reviewStarsComponent: l,
      sizeGuideComponentSlot: d,
      beforeSiblingsSlot: h,
      afterSiblingsSlot: g,
      belowTheFoldComponents: f,
      washingInstructionDrawer: _,
      afterAddToCartSlot: w,
      afterAttributesSlot: b,
      discountBadge: v
    }) => {
      var Y, X, C, I, Z, te;
      const S = j(), A = Aa.styles(), N = L(), E = J(), B = be(), z = (Y = $(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : Y.value, W = (X = $(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : X.value, u = S.content.badges, x = (C = $(
        "washing_advice_text",
        t.string()
      )) == null ? void 0 : C.value, R = B.price.number < B.priceWithoutDiscount.number, G = (v == null ? void 0 : v.enabled) && R && !B.discountButNoCampaign, V = E === "simple";
      return /* @__PURE__ */ p("section", { className: A.base, children: [
        /* @__PURE__ */ e("div", { className: A.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          re,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(W && (W == null ? void 0 : W.length) > 0),
              onClick: () => {
                const Q = document == null ? void 0 : document.getElementById("youtube-video");
                Q && Q.scrollIntoView({ behavior: "smooth" });
              },
              label: N("Product_Video_Button_Text")
            },
            ...i,
            children: /* @__PURE__ */ p("div", { className: A.badgesWrapper, children: [
              G && /* @__PURE__ */ e(
                Ce,
                {
                  label: N("PLP_Discount_Badge", {
                    saveAmount: B.priceWithoutDiscount.number - B.price.number,
                    saveProcentage: `${(I = B.discountInfo) == null ? void 0 : I.percent}%`
                  }),
                  variants: v == null ? void 0 : v.variants
                }
              ),
              u.map((Q, H) => /* @__PURE__ */ e(Ce, { label: Q.label }, H))
            ] })
          }
        ),
        /* @__PURE__ */ p("section", { className: A.detailsWrapper, children: [
          /* @__PURE__ */ p("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ p("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "wiring" }),
              ((Z = $("wiring", t.string())) == null ? void 0 : Z.value) && ((te = $("padding", t.string())) == null ? void 0 : te.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "padding" })
            ] }),
            l
          ] }),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(m.Details.Price, {}),
          h,
          /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...c
            }
          ),
          g,
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-2", children: [
            d,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: V ? /* @__PURE__ */ e(rs, {}) : /* @__PURE__ */ e(
                  ls,
                  {
                    sizePicker2Settings: n,
                    sizePickerSettings: o
                  }
                )
              }
            ),
            w
          ] }),
          /* @__PURE__ */ e(m.UspBlock, { ...s }),
          /* @__PURE__ */ e(
            m.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(m.Details.Description, {}),
        z && /* @__PURE__ */ e("ul", { className: A.highlightTextWrapper, children: z == null ? void 0 : z.split(";").map((Q, H) => /* @__PURE__ */ e("li", { className: A.highlightTextRow, children: Q }, H)) }),
        /* @__PURE__ */ p("section", { className: A.attributesWrapper, children: [
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              data: {
                attributeLabel: N("washing_advice_text"),
                value: /* @__PURE__ */ p(q, { children: [
                  x,
                  " ",
                  _
                ] })
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: N("Article_Number"),
                value: S.productKey
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "hooks_and_eye_text"
            }
          )
        ] }),
        b,
        W && /* @__PURE__ */ e("div", { className: A.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: W.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${W.split("v=")[1]}` : W,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          m.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        r,
        f
      ] });
    }
  )
), Ut = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: he.optional(),
  productDesignerSettings: he.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: le.optional(),
  sizePickerSettings: we.optional(),
  uspBlockSettings: ge.optional(),
  siblingsPickerSettings: _e.optional(),
  sizeGuideSettings: xe.optional(),
  sizeGuideTriggerSettings: Re.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  extendAccordion: t.array($e).optional(),
  accordionRootSettings: t.custom().optional()
}), ds = P(
  "ProductTemplateAsGraz",
  y(
    {
      schema: Ut,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: o,
      productDesignerSettings: n,
      sizePickerSettings: s,
      uspBlockSettings: i,
      siblingsPickerSettings: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      ecomidNudgeSlot: d,
      belowTheFoldComponents: h,
      productSku: g,
      reviewComponentSlot: f,
      extendAccordion: _,
      accordionRootSettings: w
    }) => {
      var z, W, u;
      const b = j(), v = Ba.styles(), S = L(), A = $("manufacturer", t.string()), N = un(), [E, B] = U(
        void 0
      );
      return F(() => {
        const x = () => {
          B("reviews"), setTimeout(() => {
            const R = document.getElementById("testfreaks-reviews"), G = R == null ? void 0 : R.closest('[role="region"]'), V = (G == null ? void 0 : G.parentElement) ?? R;
            V == null || V.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 50);
        };
        return window.addEventListener("pdp:open-reviews", x), () => window.removeEventListener("pdp:open-reviews", x);
      }, []), /* @__PURE__ */ e(pe, { mode: "wait", children: /* @__PURE__ */ p(
        ae.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: b.productId,
          className: v.base,
          children: [
            /* @__PURE__ */ e(dt, { template: "drawer" }),
            /* @__PURE__ */ e(
              re,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(m.StickyAddToCart, { template: "button", mode: "isNotVisible" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: v.detailsWrapper, children: [
              /* @__PURE__ */ e(
                re,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ p("div", { className: v.tagsWrapper, children: [
                /* @__PURE__ */ e(m.Details.ProductType, { ...o }),
                /* @__PURE__ */ e(N, { href: (n == null ? void 0 : n.link) ?? "", children: /* @__PURE__ */ e(m.Details.ProductType, { ...n }) })
              ] }),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              f ? /* @__PURE__ */ e("div", { className: "col-span-full lg:col-start-3 lg:col-end-4 lg:row-start-3 lg:justify-self-end empty:hidden", children: f }) : null,
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...c
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...s,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...l,
                      label: S("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                m.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (z = s == null ? void 0 : s.notifyMe) == null ? void 0 : z.enabled
                }
              ),
              /* @__PURE__ */ e(m.UspBlock, { ...i }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: S("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: w ?? {
                        type: "single",
                        collapsible: !0,
                        value: E,
                        onValueChange: (x) => B(x)
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Product_Details"),
                        content: b.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Product_Manufacturer"),
                        content: /* @__PURE__ */ p("div", { className: "flex flex-col gap-3", children: [
                          /* @__PURE__ */ e("retraced-icons", {}),
                          A == null ? void 0 : A.value
                        ] })
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: S("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    },
                    ..._ ?? []
                  ]
                }
              ),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: S("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              d,
              /* @__PURE__ */ e("span", { className: v.productId, children: S("PDP_Product_Id", {
                productId: b.productId,
                sku: g || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: v.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(W = a == null ? void 0 : a.swiperSettings) == null ? void 0 : W.settings,
                    headerSettings: {
                      heading: {
                        heading: S("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            h,
            /* @__PURE__ */ e("div", { className: v.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(u = a == null ? void 0 : a.swiperSettings) == null ? void 0 : u.settings,
                    headerSettings: {
                      heading: {
                        heading: S("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), Ft = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: le.optional(),
  sizePickerSettings: ye.optional(),
  uspBlockSettings: ge.optional(),
  siblingsPickerSettings: _e.optional(),
  imageGallerySettings: ze.optional(),
  descriptionSettings: Ve.optional(),
  nameSettings: mt.optional(),
  customSiblings: t.custom().optional()
}), us = P(
  "ProductTemplateAsSalzburg",
  y(
    {
      schema: Ft,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: o,
      nameSettings: n,
      descriptionSettings: s,
      siblingsPickerSettings: i,
      variants: c,
      customSiblings: r
    }) => {
      const l = ve.main.styles(c), d = L();
      return /* @__PURE__ */ p("section", { className: l.base, children: [
        /* @__PURE__ */ p("section", { className: l.detailsWrapper, children: [
          /* @__PURE__ */ e(
            m.Details.Name,
            {
              ...n,
              blueprint: ve.details
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Description,
            {
              ...s,
              blueprint: ve.details
            }
          ),
          r || /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...i
            }
          ),
          /* @__PURE__ */ p("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              m.Details.Price,
              {
                blueprint: ve.details
              }
            ),
            /* @__PURE__ */ e(
              m.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: l.returnPolicyWrapper, children: d("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ve.gallery,
            ...o
          }
        )
      ] });
    }
  )
), Yt = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), ps = P(
  "ProductTemplateAsLinz",
  y(Yt, () => /* @__PURE__ */ p(m.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      m.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ p("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(m.Details.Name, {}),
      /* @__PURE__ */ e(m.Details.Price, {}),
      /* @__PURE__ */ e(m.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(m.AddToCart, { template: "button" })
    ] })
  ] }))
), ms = t.discriminatedUnion("template", [
  Ht,
  Kt,
  Vt,
  $t,
  Ut,
  Ft,
  Yt
]), Js = P(
  "ProductTemplate",
  y(ms, (a) => a.template === "basic" ? /* @__PURE__ */ e(os, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(ss, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(is, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(cs, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(ds, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(us, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(ps, { ...a }) : null)
), ei = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  Ln as Accordion,
  mo as AddToCart,
  po as AddToCartButton,
  lo as AddToCartQuanityPickerRow,
  co as AddToCartQuantityPicker,
  oo as Attributes,
  eo as AttributesAsIconBlocks,
  qn as AttributesAsProgressBar,
  ao as AttributesAsRow,
  Jn as AttributesAsTags,
  no as AttributesPropsSchema,
  qs as AttributesTagsItemSchema,
  os as Basic,
  _n as Brand,
  wn as BrandSchema,
  Ro as Bundle,
  ns as BundlePromoBanner,
  gt as BundleSavingsBadge,
  Fo as BundleUpsell,
  ei as Checkmark,
  pn as CrossSvg,
  Sn as Description,
  zn as Details,
  vt as FULL_VIEWPORT_DISPLAY_SIZE,
  Yo as GiftWithPurchase,
  ds as Graz,
  ss as Helsinki,
  so as IconMinus,
  io as IconPlus,
  Yn as ImageGallery,
  Un as ImageGalleryAsGrid,
  Vn as ImageGalleryAsKeen,
  ps as Linz,
  is as Malibu,
  vn as Name,
  Tn as Price,
  Nn as PriceHistoryDrawer,
  bt as PriceSchema,
  m as Product,
  Js as ProductTemplate,
  ms as ProductTemplatePropsSchema,
  Dn as ProductType,
  Do as RelatedProducts,
  Rt as RelatedProductsImageCards,
  Bo as RelatedProductsSwiper,
  fn as Root,
  hn as RootAsDrawer,
  mn as RootAsDrawerDialog,
  ut as RootAsDrawerSchema,
  bn as RootAsGrid,
  pt as RootAsGridSchema,
  gn as RootPropsSchema,
  Ue as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  Bt as STATUS_TRANSLATIONS,
  us as Salzburg,
  ft as ShopTheLook,
  Wn as ShopTheLookItem,
  yn as ShortDescription,
  Pn as ShortDescriptionSchema,
  To as SiblingColorSwatchList,
  Co as Siblings,
  So as SiblingsImageCard,
  Jo as SizeGuide,
  Xo as SizeGuideContent,
  qo as SizeGuideDrawer,
  es as SizeGuideTrigger,
  yo as SizePicker,
  ho as SizePickerButtonGrid,
  vo as SizePickerModal,
  $o as SizeRecommendation,
  Ko as SizeRecommendationScale,
  Qn as Specifications,
  Xn as SpecificationsAsTable,
  _t as SpecificationsAsTableSchema,
  xo as StickyAddToCart,
  Lo as StickyAddToCartButton,
  Lt as Swatch,
  Ho as UspBlock,
  cs as Vienna,
  Bn as Wrapper,
  An as WrapperSchema,
  yt as ZoomCursorOverlay,
  $e as accordionItemSchema,
  In as accordionSchema,
  Dt as addToCartButtonSchema,
  At as addToCartQuantityPickerSchema,
  It as addToCartSchema,
  Nt as attributesAsIconBlocksSchema,
  Fe as attributesAsProgressBarSchema,
  Tt as attributesAsRowSchema,
  Ye as attributesAsTagsSchema,
  Zn as attributesProgressBarItemSchema,
  xn as bundleSavingsBadgeSchema,
  Ve as descriptionSchema,
  Ot as giftWithPurchaseSchema,
  St as imageGalleryAsGridSchema,
  ze as imageGalleryAsKeenSchema,
  wt as imageGalleryPropsSchema,
  mt as nameSchema,
  ht as priceHistoryDrawerSchema,
  Gt as productSizeRecommendationScaleSchema,
  Ht as productTemplateAsBasicSchema,
  Ut as productTemplateAsGrazSchema,
  Kt as productTemplateAsHelsinkiSchema,
  Yt as productTemplateAsLinzSchema,
  Vt as productTemplateAsMalibuSchema,
  Ft as productTemplateAsSalzburgSchema,
  $t as productTemplateAsViennaSchema,
  he as productTypeSchema,
  xt as relatedProductsImageCardsSchema,
  le as relatedProductsSchema,
  Et as relatedProductsSwiperSchema,
  En as shopTheLookItemSchema,
  Gn as shopTheLookSchema,
  zt as siblingColorSwatchListSchema,
  Xe as siblingsImageCardSchema,
  _e as siblingsSchema,
  jt as sizeGuideContentSchema,
  Mt as sizeGuideDrawerSchema,
  xe as sizeGuideSchema,
  Re as sizeGuideTriggerSchema,
  we as sizePickerButtonGridSchema,
  ye as sizePickerModalSchema,
  Po as sizePickerSchema,
  Vo as sizeRecommendationSchema,
  kt as specificationsPropsSchema,
  Wt as stickyAddToCartButtonSchema,
  zo as stickyaddToCartSchema,
  uo as useAddToCartLabel,
  Io as useElementVisibility,
  Pt as useImageZoom,
  ge as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
